import './index.css'

import Rails from '@rails/ujs'
import { Controller as BaseController } from 'stimulus'
import { condensedNumber } from '@app/javascript/utils/number_utils.js'

export class Controller extends BaseController {
  static targets = [
    'inboxUnreadCount',
    'alertUnreadCount'
  ]

  connect() {
    this.fetchInboxCounts()
  }

  onRefreshInboxCounts(event) {
    const { inboxId } = event.detail

    this.fetchInboxCounts({ inbox_id: inboxId })
  }

  fetchInboxCounts(params = {}) {
    Rails.ajax({
      type: 'GET',
      url: '/search/inbox_agg_counts',
      dataType: 'json',
      data: $.param(params),
      success: ({ counts }) => {
        this.updateCountElem(this.inboxUnreadCountTargets, counts.inboxes, 'unread')
        this.updateCountElem(this.alertUnreadCountTargets, counts.percolators, 'unread')
      }
    })
  }

  updateCountElem(countElems, counts, field) {
    for (const counterId in counts) {
      const count = counts[counterId][field]
      const countElem = countElems.find(elem => elem.getAttribute('data-counter-id') === `${counterId}`)

      if (countElem) {
        countElem.innerHTML = count && count > 0 ? condensedNumber(count) : ''
      }
    }
  }
}
